import React, { useState, useEffect, useCallback } from 'react';
import Typography from '@material-ui/core/Typography';

import { ListItem, ListItemIcon, ListItemText, List, Checkbox, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { fetchRecipeByCategoryId } from '../../../recipe/api';
import { expand } from 'rxjs/operators';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
  inline: {
    display: 'inline',
    color: '#777',
  },
  fullWidth: {
    width: '100%',
  },
  autoHeight: {
    height: 'fit-content',
  },
}));

export const RecipeItem = ({ label, categoryId, onClickCheckbox, ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const [recipeData, setRecipeData] = useState([]);
  const handleClick = () => setExpanded(!expanded);
  const classes = useStyles();
  const [checkedItem, setCheckedItem] = useState(false);

  const handleFetchRecipe = useCallback(async () => {
    const data = await fetchRecipeByCategoryId(categoryId);
    setRecipeData(data);
  }, [categoryId]);

  const handleChangeCheckbox = useCallback(
    (e, value) => {
      onClickCheckbox(e.target.checked, value);
    },
    [onClickCheckbox]
  );

  useEffect(() => {
    if (expanded) {
      handleFetchRecipe();
    }
  }, [expanded]);

  return (
    <>
      <ListItem button onClick={handleClick}>
        <ListItemText primary={label} />
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {recipeData.map((item, i) => (
            <ListItem key={i} button className={classes.nested}>
              <ListItemIcon className={classes.fullWidth}>
                <Checkbox
                  className={classes.autoHeight}
                  edge="start"
                  value={item}
                  onChange={(e) => handleChangeCheckbox(e, item)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': 1 }}
                />
                <ListItemText
                  style={{ color: '#222' }}
                  primary={`${i + 1}位：${item.recipeTitle}`}
                  secondary={
                    <React.Fragment>
                      <Typography component="span" variant="body2" className={classes.inline} color="textSecondary">
                        {item.recipeMaterial}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItemIcon>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  );
};
